import React from 'react';
import PassesTable from './management/PassesTable';

export const AllPasses = () => <PassesTable />;
